import React from 'react';
import MarkdownCodeBlock, { MarkdownCodeBlockProps } from './MarkdownCodeBlock';

function MarkdownPre({ children, ...markdownCodeBlockProps }: MarkdownCodeBlockProps) {
  return <MarkdownCodeBlock {...markdownCodeBlockProps}>{children}</MarkdownCodeBlock>;
}

export default MarkdownPre;
